<template>
  <div class="form-autocomplete">
    <wa-input
      v-bind="$attrs"
      ref="autocompleteForm"
      v-model="selectedValue"
      label="Select store"
      size="m"
    ></wa-input>
    <div v-show="areOptionsVisible" class="form-autocomplete__options">
      <ul class="form-autocomplete__menu">
        <li
          v-for="(option, index) in options"
          :key="index"
          class="form-autocomplete__option"
          @click="handleSelectedOption(option[optionKey])"
        >
          <div class="option-item">
            <span> {{ option[optionKey] }}</span>
            <span v-if="optionKey2?.length">({{ option[optionKey2] }})</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup>
import '@awesome.me/webawesome/dist/components/input/input.js'

import { computed, ref, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  options: {
    type: Array,
    default: () => []
  },
  optionKey: {
    type: String,
    default: ''
  },
  optionKey2: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue'])
const areOptionsVisible = ref(false)
const autocompleteForm = ref()
const selectedOption = ref('')

const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

function handleSelectedOption(value) {
  areOptionsVisible.value = false
  selectedOption.value = value
  emit('update:modelValue', value)
}

onClickOutside(autocompleteForm, () => {
  areOptionsVisible.value = false
  emit('update:modelValue', selectedOption.value)
})

watch(
  () => props.options,
  (newOptions) => {
    if (newOptions.length > 0) {
      areOptionsVisible.value = true
    }
  },
  { deep: true, immediate: false }
)
</script>

<style scoped lang="postcss">
.form-autocomplete {
  &__options {
    position: relative;
    top: 12px;

    .form-autocomplete__menu {
      position: absolute;
      z-index: 1;
      width: 100%;
      max-height: 140px;
      top: -10px;
      overflow: auto;
      margin: 0;
      padding: var(--wa-space-xs) 0;
      list-style: none;
      background-color: var(--wa-color-surface-default);
      border: 1px solid var(--wa-color-neutral-80);
      border-radius: var(--wa-border-radius-m);
    }

    .form-autocomplete__menu:empty {
      display: none;
    }

    .form-autocomplete__option {
      padding: var(--wa-space-xs) var(--wa-space-m);
      font-size: var(--wa-font-size-s);
      cursor: pointer;

      &:hover {
        background-color: var(--wa-color-neutral-90);
      }
    }
  }

  .option-item {
    display: flex;
    gap: var(--wa-space-xs);
  }
}
</style>
